import { FlagsComponentRouter } from 'flags'

import OffComponent from './flag.off/index'
import OnComponent from './flag.on/index'

const FlagToggler = FlagsComponentRouter({
  flagSubscriptions: ['feature_LEARN-18963-subnav-breadcrumbs'],
  OnComponent,
  OffComponent,
})

export default FlagToggler
